import axios from "axios";

export const createPaymentIntent = (authtoken, coupon, point, checked, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, date, time, shippingPrice, packing, currencyMultiplier, currency) =>
  axios.post(
    `${process.env.REACT_APP_API}/create-payment-intent`,
    { couponApplied: coupon, point, checked, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, date, time, shippingPrice, packing, currencyMultiplier, currency },
    {
      headers: {
        authtoken,
      },
    }
  );


export const createUpiPaymentIntent = (authtoken, coupon, point, checked, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, date, time, shippingPrice, packing) =>
  axios.post(
    `${process.env.REACT_APP_API}/create-upi-payment-intent`,
    { couponApplied: coupon, point, checked, coupon1, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, date, time, shippingPrice, packing },
    {
      headers: {
        authtoken,
      },
    }
  );

export const getPaymentLists = (authtoken) =>
  axios.get(
    `${process.env.REACT_APP_API}/get-payment/list`,
    {
      headers: {
        authtoken,
      },
    }
  );

export const createBookedPaymentIntent = (authtoken, values) =>
  axios.post(
    `${process.env.REACT_APP_API}/create-booked-intent`,
    values,
    {
      headers: {
        authtoken,
      },
    }
  );

export const detachPaymentIntent = (values, authtoken) =>
  axios.post(
    `${process.env.REACT_APP_API}/detach-customer/method-stripe`,
    values,
    {
      headers: {
        authtoken,
      },
    }
  );
